import React from "react";
import { Search, X } from "lucide-react";

const VARIANT_CONFIG = {
  team: {
    wrapperClassName: "relative flex-1",
    iconContainerClassName: "",
    iconClassName:
      "w-4 h-4 text-slate-300 absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none",
    inputClassName:
      "w-full rounded-xl border border-slate-200/80 bg-slate-50/60 pl-10 pr-4 py-2.5 text-sm text-slate-700 placeholder:text-slate-300 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-400 transition-all",
    inputStyle: undefined,
    clearButtonClassName:
      "absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-slate-200 text-slate-500 hover:bg-slate-300 transition-colors flex items-center justify-center",
    clearIconClassName: "w-3 h-3",
  },
  all: {
    wrapperClassName: "relative lg:w-[460px]",
    iconContainerClassName:
      "absolute left-3.5 top-1/2 -translate-y-1/2 w-7 h-7 rounded-lg flex items-center justify-center shadow-sm pointer-events-none",
    iconContainerStyle: { background: "linear-gradient(135deg,#4f46e5,#7c3aed)" },
    iconClassName: "w-3 h-3 text-white",
    inputClassName:
      "w-full bg-slate-50 border border-slate-200 rounded-xl pl-13 pr-10 py-2.5 text-sm text-slate-800 placeholder-slate-400 font-medium focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 transition-all",
    inputStyle: { paddingLeft: "2.75rem" },
    clearButtonClassName:
      "absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors",
    clearIconClassName: "w-4 h-4",
  },
};

const RDCandidateSearchInput = ({
  value = "",
  onChange = () => {},
  onClear,
  placeholder = "Search...",
  variant = "team",
}) => {
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.team;
  const hasValue = Boolean(String(value || "").length);

  const clear = () => {
    if (typeof onClear === "function") {
      onClear();
      return;
    }
    onChange("");
  };

  return (
    <div className={config.wrapperClassName}>
      {config.iconContainerClassName ? (
        <div
          className={config.iconContainerClassName}
          style={config.iconContainerStyle}
        >
          <Search className={config.iconClassName} />
        </div>
      ) : (
        <Search className={config.iconClassName} />
      )}
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={config.inputClassName}
        style={config.inputStyle}
      />
      {hasValue && (
        <button
          type="button"
          onClick={clear}
          className={config.clearButtonClassName}
        >
          <X className={config.clearIconClassName || "w-3 h-3"} />
        </button>
      )}
    </div>
  );
};

export default RDCandidateSearchInput;
